import React from 'react';

const Twitter: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 36" {...props}>
    <path
      fill="currentColor"
      d="M39.477 9.038c.028.39.028.782.028 1.173 0 11.921-9.074 25.657-25.657 25.657-5.11 0-9.856-1.48-13.848-4.048.726.084 1.424.111 2.178.111a18.06 18.06 0 0011.195-3.852 9.034 9.034 0 01-8.431-6.254c.558.084 1.116.14 1.703.14.81 0 1.619-.112 2.373-.308a9.019 9.019 0 01-7.231-8.85v-.112a9.082 9.082 0 004.076 1.145 9.011 9.011 0 01-4.02-7.51A8.95 8.95 0 013.07 1.78a25.632 25.632 0 0018.594 9.436c-.14-.67-.223-1.368-.223-2.066 0-4.97 4.02-9.018 9.017-9.018a8.996 8.996 0 016.59 2.848A17.754 17.754 0 0042.77.802a8.993 8.993 0 01-3.964 4.97c1.815-.196 3.574-.698 5.193-1.396a19.384 19.384 0 01-4.523 4.662z"
    ></path>
  </svg>
);

export default Twitter;
